import React from 'react'
import { Link } from 'react-router-dom';
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next';

import GroupsIcon from "@mui/icons-material/Groups";
import AssessmentIcon from '@mui/icons-material/Assessment';
import AssignmentIcon from '@mui/icons-material/Assignment';

const Dashboard = () => {
  const { t } = useTranslation();

  return (
    <div className='dashboard'>
      <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>
        {t("facilitator.dashboard.title")}
      </h2>
      <div className='linkButtons' style={{display: "flex", flexWrap:"wrap", gap: "1rem", paddingTop: "1rem"}}>
        <Button variant='contained' color="info" startIcon={<GroupsIcon />} component={Link} to="/students">
          {t("facilitator.dashboard.linkButtons_students")}
        </Button>
        <Button variant='contained' color="info" startIcon={<AssessmentIcon />} component={Link} to="/results">
          {t("facilitator.dashboard.linkButtons_results")}
        </Button>
        <Button variant='contained' color="info" startIcon={<AssignmentIcon />} component={Link} to="/intervention">
          {t("facilitator.dashboard.linkButtons_intervention")}
        </Button>
      </div>
    </div>
  )
}

export default Dashboard